import { render, staticRenderFns } from "./base.vue?vue&type=template&id=d155a108&"
import script from "./base.vue?vue&type=script&lang=js&"
export * from "./base.vue?vue&type=script&lang=js&"
import style0 from "./base.vue?vue&type=style&index=0&id=d155a108&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NavBarHeader: require('/app/appsumo/nuxt/components/common/NavBarHeader.vue').default,Button: require('/app/appsumo/nuxt/components/wishlists/Button.vue').default,Footer: require('/app/appsumo/nuxt/components/common/Footer.vue').default,ScrollToTop: require('/app/appsumo/nuxt/components/common/ScrollToTop.vue').default})
